'use client';

import { Link } from '@/i18n/routing';
import Image from 'next/image';
import { useTranslations } from 'next-intl';
import { cn } from '@ecom/helper-react-class-combine';
import { imageLoader } from '@/shared/utils/image-loader';

interface WTLogoHomeLinkProps {
  className?: string;
}

export const WTLogoHomeLink = ({ className }: WTLogoHomeLinkProps) => {
  const t = useTranslations('Home.header');

  return (
    <Link
      href='/'
      className={cn(
        'focus-visible:ring-primary mx-2 focus:outline-hidden focus-visible:ring-2 focus-visible:ring-offset-1',
        className,
      )}
      aria-label={t('returnToHomepage')}
    >
      <div className='relative h-[42px] w-[253px]'>
        <Image
          src='/img/WT_games_white.svg'
          loader={imageLoader}
          alt={t('logoAltText')}
          fill
          sizes='253px'
          className='object-contain'
        />
      </div>
    </Link>
  );
};
